var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5306 7.78104L9.53055 19.781C9.4609 19.8508 9.37818 19.9061 9.28713 19.9438C9.19609 19.9816 9.09849 20.001 8.99993 20.001C8.90137 20.001 8.80377 19.9816 8.71272 19.9438C8.62168 19.9061 8.53896 19.8508 8.4693 19.781L3.2193 14.531C3.07857 14.3903 2.99951 14.1994 2.99951 14.0004C2.99951 13.8014 3.07857 13.6105 3.2193 13.4698C3.36003 13.3291 3.55091 13.25 3.74993 13.25C3.94895 13.25 4.13982 13.3291 4.28055 13.4698L8.99993 18.1901L20.4693 6.71979C20.61 6.57906 20.8009 6.5 20.9999 6.5C21.199 6.5 21.3898 6.57906 21.5306 6.71979C21.6713 6.86052 21.7503 7.05139 21.7503 7.25042C21.7503 7.44944 21.6713 7.64031 21.5306 7.78104Z",
    fill: "#F96619"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.dfc0dce29f8b2567f0829d87314697df.svg";
export { ForwardRef as ReactComponent };